import React from 'react';
import Slider from 'react-slick';
import Test_1 from '../../../assets/images/home_page_3/testimonials/01.png';
import Test_2 from '../../../assets/images/home_page_3/testimonials/02.png';
import Test_3 from '../../../assets/images/home_page_3/testimonials/03.png';

const testimonials = [
    {
        id: 1,
        image: Test_1,
        name: 'Milan Annas',
        position: 'Service Holder',
        text: 'The design of the Jack&Jons Shirt is simply stunning. The attention to details and this is a quality of materials used exceeded my expectations. I\'ve received numerous compliments whenever I wear it. The fit is perfect.',
        rating: 5,
    },
    {
        id: 2,
        image: Test_2,
        name: 'John Doe',
        position: 'Service Holder',
        text: 'The design of the Jack&Jons Shirt is simply stunning. The attention to details and this is a quality of materials used exceeded my expectations. I\'ve received numerous compliments whenever I wear it. The fit is perfect.',
        rating: 5,
    },
    {
        id: 3,
        image: Test_3,
        name: 'Stephanie',
        position: 'Service Holder',
        text: 'The design of the Jack&Jons Shirt is simply stunning. The attention to details and this is a quality of materials used exceeded my expectations. I\'ve received numerous compliments whenever I wear it. The fit is perfect.',
        rating: 5,
    },
];

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
};
const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
};

const Testimonial = () => {
    

    return (
        <section id="testimonial-three" className="testimonial-three-main-block">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="section">
                            <div className="section-sub-title">Testimonial</div>
                            <h4 className="section-title-three">What Say’s Our customer</h4>
                        </div>
                        <Slider className="testimonial-three-nav" {...settings2}>
                            {testimonials.map(testimonial => (
                                <div key={testimonial.id} className="testimonial-three-img">
                                    <img
                                        src={testimonial.image}
                                        className="img-fluid"
                                        alt={testimonial.name}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className="col-xl-9 col-lg-8 col-md-8">
                        <Slider className="testimonial-three-for" {...settings}>
                            {testimonials.map(testimonial => (
                                <div key={testimonial.id} className="testimonial-three-block">
                                    <div className="testimonial-three-rating">
                                        <ul>
                                            {Array.from({ length: testimonial.rating }, (_, index) => (
                                                <li key={index}>
                                                    <i className="flaticon-star" />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <p>{testimonial.text}</p>
                                    <div className="testimonial-three-dtl">
                                        <h5 className="testimonial-three-name jakarta-font">
                                            {testimonial.name}
                                        </h5>
                                        <div className="post">{testimonial.position}</div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;